import { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Tooltip,  IconButton, Box, useTheme } from '@mui/material';
import { User } from 'lucide-react';
import type { RootState } from '../types/store';
import AuthPopup from './popup/auth';
import UserPopup from './popup/user';

export default function AuthContainer() {
    const theme = useTheme();
    const auth = useSelector((state:RootState) => state.auth);
    const [open, setOpen] = useState(false);
    const [openTooltip, setOpenTooltip] = useState(false);
    const timeoutRef = useRef<number|null>(null);
    
    useEffect(() => {
        if(auth.login.loggedIn === true || auth.register.isRegistered === true) {
            handleClose();
            handleTooltip();
        }
    }, [auth.login.loggedIn, auth.register.isRegistered]);

    useEffect(() => {
        return () => {
            // Cleanup on unmount
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, []);
  
    const handleOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
    }
    
    const handleTooltip = () => {
        setOpenTooltip(true);

        // Clear existing timeout if any
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        // Set timeout to close tooltip after 5 seconds
        timeoutRef.current = window.setTimeout(() => {
            setOpenTooltip(false);
            timeoutRef.current = null;
        }, 5000);
    };
    
    return (<>
        <Box sx={{position: 'absolute', top: theme.spacing(2), right: theme.spacing(2)}}>
            <div style={{borderRadius: '20px', backgroundColor: '#55585B'}}>
                <Tooltip title={auth.user.motd} placement="left" open={openTooltip} disableFocusListener disableHoverListener disableTouchListener>
                    <IconButton onClick={handleOpen} color="primary">
                        <User />
                    </IconButton>
                </Tooltip>
            </div>
        </Box>
        {auth.user.id > 0 && open && <UserPopup open={open} onClose={handleClose} />}
        {auth.user.id === 0 && open && <AuthPopup open={open} onClose={handleClose} />}
    </>);
}